"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = require("./theme");
function FloatingActionButton(_a) {
  var onClick = _a.onClick,
    icon = _a.icon,
    className = _a.className,
    style = _a.style;
  var background = theme_1.useBackgroundColor(className, true);
  return react_1.default.createElement("div", {
    role: "button",
    onClick: onClick,
    onKeyPress: onClick,
    tabIndex: 0,
    className: classnames_1.default('fixed z-40 right-0 bottom-0 mr-4 mb-4 shadow-lg flex text-white items-center justify-center w-16 h-16 rounded-full', background),
    style: style
  }, react_1.default.cloneElement(icon, {
    size: 30,
    className: icon.props.className || 'text-white'
  }));
}
exports.FloatingActionButton = FloatingActionButton;